import SimpleLink from './simpleLink'

export default SimpleLink
